import axios, { AxiosResponse } from 'axios';
import { SubscriptionModel } from './subscription.input';

const routeName = `/subscriptions`;
export async function getEventsSubscriptions(eventId: number): Promise<any> {
    const filter = {
        "where": {
            "eventId": eventId
        },
        "include": [
        {
            "relation": "guests",
            "scope": {
                "include": [
                {
                    "relation": "answers",
                    "scope": {
                        "include": [{
                          "relation": "question"
                        }]
                      }
                }
                ]
            }
        },
        {
            "relation": "paymentOptions",
        }
        ]
    }

    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName+'?filter='+JSON.stringify(filter))
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getEventsSubscriptions !',err);
            return {error : err};
        });
}

export async function getSubscriptionsPaymentOption(subsctiptionId: number): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName+'/'+subsctiptionId+'/payment-options')
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getSubscriptionsPaymentOption !',err);
            return {error : err};
        });
}

export async function getRecentSubscriptionsForEventCategory(eventCategoryId: number): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName+'/event/'+eventCategoryId)
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getRecentSubscriptionsForEventCategory !',err);
            return {error : err};
        });
}

export async function exportCsv(eventId: number): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL + '/events/'+eventId+'/subscriptions/csv')
        .then(resp => {
            const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'Total_inscrits.csv');
            document.body.appendChild(fileLink);
            fileLink.click();
        })
        .catch(err => {
            console.log('error exportCsv !',err);
            return {error : err};
        });
}

export async function postSubscription(data: any): Promise<any> {
    return axios.post(process.env.VUE_APP_CJ_API_URL + routeName,data)
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error postSubscription !',err);
            return {error : err};
        });
}

export async function getSubscription(id: number): Promise<any> {
    const filter = {
      "include": [{
        "relation": "guests",
        "scope": {
          "include": [{
            "relation": "answers",
            "scope": {
                "include": [{
                  "relation": "question"
                }]
              }
          }]
        }
      }]
    };
    return axios.get(process.env.VUE_APP_CJ_API_URL + routeName+'/'+id+'?filter='+JSON.stringify(filter))
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error getSubscription !',err);
            return {error : err};
        });
}

export async function patchSubscription(data: any): Promise<any> {
    if (data.updatedAt) delete data.updatedAt;
    if (data.createdAt) delete data.createdAt;
    
    return axios.patch(process.env.VUE_APP_CJ_API_URL + routeName+'/'+data.id,data)
        .then(resp => {
            
            return {data: 'success'};
        })
        .catch(err => {
            console.log('error patchSubscription !',err);
            return {error : err};
        });
}

export async function exportCsvByGuestCategory(eventId: number,eventGuestCategoryId: number, eventGuestCategoryName: string ): Promise<any> {
    return axios.get(process.env.VUE_APP_CJ_API_URL + '/events/'+eventId+'/subscriptions/'+eventGuestCategoryId+'/csv')
        .then(resp => {
            const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'Total_inscrits_'+eventGuestCategoryName+'.csv');
            document.body.appendChild(fileLink);
            fileLink.click();
        })
        .catch(err => {
            console.log('error exportCsvByGuestCategory !',err);
            return {error : err};
        });
}

export async function patchSubscriptionCheckIn(id: number): Promise<any> {
    
    return axios.patch(process.env.VUE_APP_CJ_API_URL + routeName+'/'+id+'/checkin')
        .then(resp => {
            
            return {data: 'success'};
        })
        .catch(err => {
            console.log('error patchSubscriptionCheckIn !',err);
            return {error : err};
        });
}


export async function postSubscriptionWithGuestsAndAnswers(data: SubscriptionModel): Promise<any> {
    return axios.post(process.env.VUE_APP_CJ_API_URL + routeName+'/guests/answers',data)
        .then(resp => {
            
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error postSubscriptionWithGuestsAndAnswers !',err);
            return {error : err};
        });
}

export async function putSubscriptionWithGuestsAndAnswers(data: SubscriptionModel, notify?: boolean): Promise<any> {    
    const notifyQuery = (notify != null) ? `?notify=${notify}` : '';
    return axios.put(`${process.env.VUE_APP_CJ_API_URL}${routeName}/${data.id}/guests/answers${notifyQuery}`,data)
        .then(resp => {
            
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error putSubscriptionWithGuestsAndAnswers !',err);
            return {error : err};
        });
}

export async function deleteSubscription(id: number): Promise<any> {
    return axios.delete(process.env.VUE_APP_CJ_API_URL + routeName+'/'+id+'/withguestdata')
        .then(resp => {
            return {data: id};
        })
        .catch(err => {
            console.log('error deleteSubscription !',err);
            return {error : err};
        });
}